import { useMasterSubjectsSelector } from '../../../redux/selector';
import TreeMenu from '../../common/TreeMenu';
import usePermission from '../../../hooks/usePermission';

export default function ExamManagement() {
  const subjects = useMasterSubjectsSelector();

  const dataTree = [
    {
      id: 1,
      title: 'Import đề',
      url: '/exam-management/import',
      children: [],
    },
    {
      id: 3,
      title: 'Ngân hàng đề thi',
      children: subjects.map((subject) => ({
        id: subject.id,
        title: subject.name,
        url: `/exam-management/subject/${subject.id}/exams`,
      })),
    },
  ];

  usePermission(['ROLE_ADMIN', 'ROLE_COMPILER', 'ROLE_MASTER_COMPILER']);

  return <TreeMenu dataTree={dataTree} />;
}
